/**
 * What a contract is called wherever it is listed: its agreement name, '' while
 * it has none. The short contract description is gone (ClickUp 869fnhht3).
 */
export const contractTitle = (contract: { contractName?: string | null }) =>
  contract.contractName?.trim() || '';
